import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Bar from './Bar';
import Title from './Title';
import Results from './Results';

const Root = styled.div`
  flex: 1;
  display: flex;
  position: relative;
  align-self: stretch;
  align-items: center;
  flex-direction: column;
  justify-content: center;
`;

function Search({ className }) {
  return (
    <Root className={className}>
      <Title>Hi. What do you need?</Title>
      <Bar />
      <Results />
    </Root>
  );
}

Search.propTypes = {
  className: PropTypes.string,
};

Search.defaultProps = {
  className: '',
};

export default Search;
